export default __webpack_public_path__ + "static/media/contact.40d2e143.svg";